import { useEffect, useState } from 'react'
import type { BrokerSnapshot } from '@shared/broker'
import type { BrokerName } from '@shared/brokers'
import { brokerApi } from '../lib/api'

/** A broker's live snapshot over SSE (the server pushes on every change). */
export function useBrokerStream(enabled = true, broker: BrokerName = 'ibkr'): { snapshot: BrokerSnapshot | null; live: boolean } {
  const [snapshot, setSnapshot] = useState<BrokerSnapshot | null>(null)
  const [live, setLive] = useState(false)
  useEffect(() => {
    if (!enabled) return
    return brokerApi.subscribe(setSnapshot, setLive, broker)
  }, [enabled, broker])
  return { snapshot, live }
}
